import React from 'react';
import ContactForm from '@/components/ContactForm';

const JoinUsSection = () => {
  return (
    <section className="w-full py-12 md:py-24 lg:py-32 bg-blue-50">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl font-bold tracking-tighter text-blue-900 sm:text-4xl md:text-5xl">
          Únete a Nuestra Comunidad
        </h2>
        <p className="max-w-[700px] mx-auto text-blue-800 md:text-xl lg:text-base xl:text-xl my-4">
          En Escuela de Lenguaje Arcoíris, creemos en el potencial de cada estudiante. 
          ¡Sé parte de nuestra familia educativa!
        </p>
        
        <div className="flex flex-col items-center gap-4">
          <img
            src="/images/arcoiris.png"
            alt="Milenito"
            className="w-1/2 max-w-xs my-1"
          />
          <ContactForm variant="default" />
        </div>
      </div>
    </section>
  );
};

export default JoinUsSection;
